// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import ModulePlanningClassModel from '../../model/module-planning-class-model';
import ModulePlanningClassDTO from '../dto/module-planning-class-dto';
import dtoSchema from '../schemas/module-planning-class-schema';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class ModulePlanningClassModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<ModulePlanningClassDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.name = data.name ?? undefined;
      this.primaryLeadLecturerId = data.primaryLeadLecturerId;
      this.startYear = data.startYear;
      this.isPrototype = data.isPrototype;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  name?: string;
  /**
  * @type {int32}
  */
  primaryLeadLecturerId?: number;
  /**
  * @type {int32}
  */
  startYear?: number;
  /**
  */
  isPrototype?: boolean;

  static toModel(dto: DeepPartial<ModulePlanningClassDTO>): ModulePlanningClassModel;
  static toModel(dto: DeepPartial<ModulePlanningClassDTO> | undefined | null): ModulePlanningClassModel | undefined;
  static toModel(dto: DeepPartial<ModulePlanningClassDTO> | undefined | null): ModulePlanningClassModel | undefined {
    return dto ? new ModulePlanningClassModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<ModulePlanningClassModel> | ModulePlanningClassModel): ModulePlanningClassDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      links: unwrapped.links,
      name: unwrapped.name,
      primaryLeadLecturerId: unwrapped.primaryLeadLecturerId,
      startYear: unwrapped.startYear,
      isPrototype: unwrapped.isPrototype,
    } as ModulePlanningClassDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for ModulePlanningClassModel, can not map to ModulePlanningClassDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
